module.exports = __webpack_public_path__ + "static/media/active.73a48405.png";